import {createGlobalStyle} from "styled-components"

import "../../fonts/HelveticaNeue/HelveticaNeue.css"

const GlobalStyles = createGlobalStyle`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    * {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -moz-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    html, body {
      margin: 0;
      padding: 0;
      min-height: 100%;
    }

    body {
      text-rendering: optimizeSpeed;
    }

    img {
      max-width: 100%;
      display: block;
    }

    input,
    button,
    textarea,
    select {
      font: inherit;
    }

    @media (prefers-reduced-motion: reduce) {
      * {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
      }
    }

    body {
      font-family: "HelveticaNeue";
      font-size: 13px;
      line-height: 1.2;
      font-weight: normal;
      color: #000;
    }

    #react-cico {
      margin: 0 12px 70px;
    }
`

export default GlobalStyles
